import { render, staticRenderFns } from "./MostPopular.vue?vue&type=template&id=adb22386&scoped=true"
import script from "./MostPopular.vue?vue&type=script&lang=js"
export * from "./MostPopular.vue?vue&type=script&lang=js"
import style0 from "./MostPopular.vue?vue&type=style&index=0&id=adb22386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb22386",
  null
  
)

export default component.exports